module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"chai","commonjs2":"chai","amd":"chai","root":"chai"}
 ** module id = 6
 ** module chunks = 0
 **/